export default "__VITE_ASSET__Dyi9x3ty__"